import React, { ReactNode, useState, MouseEvent, ReactElement, cloneElement } from "react";
import { Button } from "reactstrap";
import ConfirmModal from "../ConfirmModal";

export type ConfirmableButtonProps = {
  onConfirm?: (e: MouseEvent<HTMLButtonElement>) => void;
  title?: string;
  confirmMessage: string;
  confirmBtnText?: string;
  children?: ReactNode;
  primaryBtnColor?: string;
  secondaryBtn?: string;
  secondaryBtnColor?: string;
  trigger?: ReactElement;
  triggerBtnColor?: string;
};

const ConfirmableButton: React.FC<ConfirmableButtonProps> = ({
  onConfirm,
  title = "",
  confirmMessage = "¿Está seguro que desea realizar esta accion?",
  children,
  confirmBtnText,
  primaryBtnColor,
  secondaryBtn,
  secondaryBtnColor,
  trigger,
  triggerBtnColor = "primary",
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const triggerConfirm = (e: MouseEvent<HTMLButtonElement>) => {
    if (onConfirm) {
      onConfirm(e);
    }
    setIsOpen(false)
  };

  const toggleModal = () => {
    setIsOpen((prev) => !prev);
  };

  const openModal = () => {
    setIsOpen(true);
  };

  let triggerWithHandler;

  if (!trigger) {
    triggerWithHandler = <Button color={triggerBtnColor} onClick={openModal}>
      {children || confirmBtnText}
    </Button>
  } else {
    triggerWithHandler = cloneElement(trigger, {
      onClick: openModal
    });

  }

  return (
    <>
      {triggerWithHandler}
      <ConfirmModal
        toggle={toggleModal}
        isOpen={isOpen}
        title={title}
        onConfirm={triggerConfirm}
        primaryBtn={confirmBtnText}
        primaryBtnColor={primaryBtnColor}
        secondaryBtn={secondaryBtn}
        secondaryBtnColor={secondaryBtnColor}
      >
        {confirmMessage}
      </ConfirmModal>
    </>
  );
};

export default ConfirmableButton;
